"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.properties = exports["default"] = void 0;

var _avatar = _interopRequireDefault(require("./avatar"));

var _badge = _interopRequireDefault(require("./badge"));

var _breadCrumbs = _interopRequireDefault(require("./breadCrumbs"));

var _button = _interopRequireWildcard(require("./button"));

var _buttonedTabs = _interopRequireDefault(require("./buttonedTabs"));

var _checkbox = _interopRequireDefault(require("./checkbox"));

var _chip = _interopRequireDefault(require("./chip"));

var _dialog = _interopRequireDefault(require("./dialog"));

var _icon = _interopRequireDefault(require("./icon"));

var _input = _interopRequireWildcard(require("./input"));

var _dropdown = _interopRequireWildcard(require("./dropdown"));

var _link = _interopRequireDefault(require("./link"));

var _list = _interopRequireDefault(require("./list"));

var _radio = _interopRequireWildcard(require("./radio"));

var _switch = _interopRequireWildcard(require("./switch"));

var _table = _interopRequireDefault(require("./table"));

var _tabs = _interopRequireDefault(require("./tabs"));

var _text = _interopRequireDefault(require("./text"));

var _tooltip = _interopRequireDefault(require("./tooltip"));

var _accordion = _interopRequireDefault(require("./accordion"));

var _textarea = require("./textarea");

var _message = _interopRequireWildcard(require("./message"));

var _searchableInput = _interopRequireWildcard(require("./searchableInput"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var v1 = {
  avatar: _avatar["default"],
  badge: _badge["default"],
  breadCrumbs: _breadCrumbs["default"],
  button: _button["default"],
  buttonedTabs: _buttonedTabs["default"],
  checkbox: _checkbox["default"],
  chip: _chip["default"],
  dialog: _dialog["default"],
  dropdown: _dropdown["default"],
  icon: _icon["default"],
  input: _input["default"],
  link: _link["default"],
  list: _list["default"],
  radio: _radio["default"],
  "switch": _switch["default"],
  table: _table["default"],
  tabs: _tabs["default"],
  text: _text["default"],
  tooltip: _tooltip["default"],
  accordion: _accordion["default"],
  searchableInput: _searchableInput["default"],
  message: _message["default"]
};
var properties = {
  input: _input.inputProperties,
  button: _button.buttonProperties,
  dropDown: _dropdown.dropDownProperties,
  radio: _radio.radioProperties,
  message: _message.messageProperties,
  textarea: _textarea.textareaProperties,
  "switch": _switch.switchProperties,
  searchableInput: _searchableInput.searchableInputProperties
};
exports.properties = properties;
var _default = v1;
exports["default"] = _default;